<template>
  <div class="addUserMainDiv" ref="addUserMainDiv">
    <PageHeader :title="title" :items="headerItems" />
    <div class="main">
      <div>
        <div>
          <div class="d-flex align-items-center mb-3 p-0">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">اطلاعات کاربر</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="section row">
            <b-col cols="12" md="6">
              <div class="mb-3">
                <BaseText @input="formData.firstName = $event" required :errortext="errorText" :showError="submit && !formData.firstName" title="نام" placeholder="نام" />
              </div>
              <div class="mb-3">
                <BaseText @input="formData.enFirstName = $event" title="Name" placeholder="Name" />
              </div>
              <div class="mb-3">
                <BaseText
                  inputType="number"
                  :maxlength="11"
                  @input="formData.mobile = $event"
                  title="تلفن همراه"
                  placeholder="تلفن همراه"
                  required
                  :errortext="mobileErrorText || phoneNumberErrorText || errorText"
                  :showError="(submit && !formData.mobile) || (submit && phoneNumberError)"
                />
              </div>
              <div class="mb-3">
                <BaseText inputType="number" :maxlength="10" @input="formData.nationalCode = $event" title="کد ملی" placeholder="کد ملی" />
              </div>
              <div class="mb-3">
                <BaseText @input="formData.fatherName = $event" title="نام پدر" placeholder="نام پدر" />
              </div>
              <div class="mb-3">
                <BaseText @input="formData.fieldOfStudy = $event" title="رشته" placeholder="رشته" />
              </div>
            </b-col>
            <b-col cols="12" md="6">
              <div class="mb-3">
                <BaseText
                  @input="formData.lastName = $event"
                  title="نام خانوادگی"
                  placeholder="نام خانوادگی"
                  required
                  :errortext="errorText"
                  :showError="submit && !formData.lastName"
                />
              </div>
              <div class="mb-3">
                <BaseText @input="formData.enLastName = $event" title="Last Name" placeholder="Last Name" />
              </div>
              <div class="mb-3">
                <BaseText inputType="number" :maxlength="14" @input="formData.telephone = $event" title="تلفن ثابت" placeholder="تلفن ثابت" />
              </div>
              <div class="mb-3">
                <DateTimeOffset
                  :value="formData.birthDate"
                  @input="formData.birthDate = $event"
                  title="تاریخ تولد"
                  placeholder="تاریخ تولد"
                  :hasDefaultDate="false"
                  :key="formData.birthDate.length"
                />
              </div>
              <div class="mb-3">
                <BaseText inputType="text" :maxlength="14" @input="formData.job = $event" title="شغل" placeholder="شغل" />
              </div>
              <div class="mb-3">
                <BaseText inputType="text" :maxlength="14" @input="formData.educationRate = $event" title="میزان تحصیلات" placeholder="میزان تحصیلات" />
              </div>
            </b-col>
            <div class="">
              <BaseText @input="formData.email = $event" title="ایمیل" placeholder="ایمیل" />
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center mb-3 p-0">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">اطلاعات پستی</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="section">
            <b-row class="mb-3">
              <b-col cols="6">
                <BaseText inputType="text" :maxlength="100" @input="formData.province = $event" title="استان" placeholder="استان" />
              </b-col>
              <b-col cols="6">
                <BaseText inputType="text" :maxlength="100" @input="formData.city = $event" title="شهر" placeholder="شهر" />
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="12">
                <TextAreaInput @input="formData.address.addressText = $event" title="آدرس" placeholder="آدرس" />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <BaseText inputType="number" :maxlength="10" @input="formData.address.postalCode = $event" title="کد پستی" placeholder="کد پستی" />
              </b-col>
            </b-row>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center mb-3 p-0">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">اطلاعات تکمیلی</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="inner__style">
            <div v-if="!formData.nationalCodeImage" class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center" @click="$bvModal.show('cropperModal')">
              <div>
                <i class="fas fa-cloud-upload-alt icon-size"></i>
                <div class="upload-text-size">برای آپلود عکس خود کلیک کنید</div>
              </div>
            </div>
            <div v-else class="grand-parent">
              <div class="upload-photo-parent">
                <div class="uploaded-photo">
                  <div class="remove-icon" @click="formData.nationalCodeImage = ''">
                    <i class="fa fa-times"></i>
                  </div>
                  <img class="previewImage" :src="formData.nationalCodeImage" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center mb-3 p-0">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">یادداشت</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="section">
            <div>
              <b-row>
                <b-col cols="12">
                  <TextAreaInput @input="formData.adminNote = $event" title="یادداشت" placeholder="یادداشت" />
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center mb-3 p-0">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">مشخصات کاربر</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="section">
            <b-row>
              <b-col class="d-flex justify-content-start align-items-center" lg="4">
                <i class="fas fa-user-circle userPic" v-if="!UserAvatar"></i>
                <img v-else :src="UserAvatar" alt="" class="user-avatar" />
                <div @click="$bvModal.show('chooseImage')" class="choosePic">انتخاب عکس</div>
                <b-modal id="chooseImage" no-close-on-esc hide-footer centered size="md" header header-close-variant="dark" cancel-title>
                  <template #modal-title>کراپ عکس</template>
                  <div class="p-3">
                    <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="changeUserAvatar($event)" />
                  </div>
                </b-modal>
              </b-col>
              <b-col class="d-flex justify-content-start align-items-center" lg="4">
                <FormTags isAddUser @tagListUpdate="tagListUpdate($event)" :tags="FormTagData.tags" />
              </b-col>
              <b-col class="d-grid" lg="4">
                <RangeSlider @rate="userRate($event)" :options="sliderOptions" />
              </b-col>
            </b-row>
          </div>
        </div>
        <div>
          <div class="buttonClass">
            <Button @click.native="onSubmit" btnClass="submitButton" text="ثبت" :loading="disableSubmit" />
            <b-button @click="$bvModal.show('cancleModal')" class="cancleButton">
              <span class="cancleTitle">انصراف</span>
            </b-button>
            <b-modal id="cancleModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
              <div class="error-wrapper">
                <div class="mb-4">
                  <img src="@/assets/images/checked1.svg" />
                </div>
                <div class="error-title">آیا از انصراف خود مطمئن هستید؟</div>
                <div class="buttons">
                  <div @click="$bvModal.hide('cancleModal')">
                    <button class="cancelButton">خیر</button>
                  </div>
                  <div @click="goToListPage">
                    <button class="approveButton">بلی</button>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
          <Toast title="لطفا همه اطلاعات را تکمیل کنید" :error="true" :showToast="alertFlag" />
          <b-modal id="cropperModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
            <template #modal-title>کراپ عکس</template>
            <div class="p-3">
              <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="uploadImage($event)" :cropSize="imageCrop" cropShape="rectangle-stencil" />
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header'
import BaseText from '../../common/form/formModules/BaseText.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import FormTags from '../../common/form/formModules/FormTags.vue'
import ImageCropper from '../../user/ImageCropper.vue'
import RangeSlider from '../../common/rangeSlider.vue'
import { invoiceMixins } from '../../../utils/mixins'
import userDataProvider from '../../../services/user'
import invoiceDataProvider from '../../../services/invoice'
import fileMannager from '../../../services/file'
import Toast from '../../common/Toast.vue'
import Button from '../../common/Button.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
export default {
  components: {
    PageHeader,
    BaseText,
    TextAreaInput,
    ImageCropper,
    RangeSlider,
    FormTags,
    Toast,
    Button,
    DateTimeOffset,
  },
  mixins: [invoiceMixins],
  data() {
    return {
      imageCrop: { width: 400, height: 200 },
      cropperLoading: false,
      headerItems: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'جدول مدیریت کاربران',
          active: true,
        },
      ],
      firstNameError: false,
      lastNameError: false,
      mobileErrorText: '',
      title: 'مدیریت کاربران',
      disableSubmit: false,
      resetCityFlag: true,
      searchedProvinceData: [],
      searchedCityData: [],
      selectProvince: '',
      selectCity: '',
      cityDisabled: true,
      formData: {
        firstName: null,
        lastName: null,
        enFirstName: null,
        educationRate: null,
        enLastName: null,
        fieldOfStudy: null,
        nationalCodeImage: null,
        telephone: null,
        mobile: null,
        birthDate: '',
        job: null,
        email: null,
        adminNote: null,
        nationalCode: null,
        fatherName: null,
        companyId: null,
        province: null,
        city: null,
        customerSatisfactionRate: 0,
        address: {
          cityId: 0,
          addressText: null,
          postalCode: null,
        },
        tag: [],
      },
      FormTagData: {
        newTagPlaceholder: 'اضافه کردن تگ',
        tags: [],
        newTag: '',
      },
      sliderOptions: {
        text: 'رضایت از مشتری',
        dotSize: 0,
        width: '100%',
        height: 7,
        contained: false,
        direction: 'rtl',
        dataLabel: 'label',
        dataValue: 'value',
        min: 0,
        max: 10,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 1,
        adsorb: false,
        lazy: true,
        tooltip: 'always',
        tooltipPlacement: 'top',
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: true,
        enableCross: true,
        fixed: false,
        order: true,
        marks: {
          0: '0',
          10: '10',
        },
        process: true,
        processStyle: { backgroundColor: '#556ee6' },
        tooltipStyle: { backgroundColor: '#556ee6', borderColor: '#556ee6', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2px 1px' },
      },
      errorText: 'وارد کردن این فیلد الزامی است',
      submit: false,
      phoneNumberErrorText: '',
      phoneNumberError: false,
      UserAvatar: null,
      alertFlag: false,
      forceUpdateFlag: true,
    }
  },
  watch: {
    'formData.birthDate'(c) {
      if (c && !c.includes('T')) {
        this.formData.birthDate = this.formData.birthDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
  },
  methods: {
    userRate(e) {
      this.formData.customerSatisfactionRate = e
    },
    goUp() {
      this.$refs.addUserMainDiv.scrollTop = 0
    },
    goToListPage() {
      this.$router.push({ path: '/list/user' })
    },
    onSubmit() {
      this.submit = true
      if ((!this.formData.firstName && !this.formData.lastName) || !this.formData.mobile) {
        this.goUp()
        return false
      } else if (this.formData.mobile) {
        const mobileNumberRegex = /^09\d{9}$/
        const checkMobileNumber = mobileNumberRegex.test(String(this.formData.mobile))
        if (!checkMobileNumber) {
          this.goUp()
          this.phoneNumberError = true
          this.phoneNumberErrorText = 'شماره همراه کاربر را صحیح وارد نمایید .'
          return false
        }
      }

      this.disableSubmit = true
      userDataProvider
        .addNewUser({ ...this.formData, birthDate: this.formData.birthDate ? this.formData.birthDate : null })
        .then((res) => {
          this.$router.push({ path: '/list/users' })
          this.disableSubmit = false
        })
        .catch((error) => {
          if (error.response.status === 409) {
            this.goUp()

            this.phoneNumberError = true
            this.mobileErrorText = error.response.data.message
          }
          this.disableSubmit = false
        })
    },
    changeUserAvatar(payload) {
      this.cropperLoading = true
      fileMannager
        .addImage({
          base64image: payload,
        })
        .then((res) => {
          this.cropperLoading = false

          this.UserAvatar = res.data.data.downloadUrl
          this.$bvModal.hide('chooseImage')
        })
      setTimeout(() => {
        this.formData.avataImageUrl = this.UserAvatar
      }, 2500)
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.formData.nationalCodeImage = req.data.data.downloadUrl
      this.cropperLoading = false
      this.$bvModal.hide('cropperModal')
    },
    tagListUpdate(payload) {
      for (let i = 0; i < payload.length; i++) {
        this.formData.tag.push({ title: payload[i] })
        this.FormTagData.tags.push({ title: payload[i] })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.addUserMainDiv {
  max-height: 88vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;
}
::-webkit-scrollbar {
  display: none;
}
.main {
  background: #ffffff;
  box-shadow: 0px 10px 20px rgba(18, 38, 63, 0.0313726);
  border-radius: 8px;
  padding: 30px;
}
.userInformation {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #444444;
}
.submitButton {
  font-size: 14px !important;
  padding: 8px 45px !important;
  color: white !important;
  background: #556ee6 !important;
  border: 1px solid #556ee6 !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.section {
  padding: 26px 30px;
  margin-bottom: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.userPic {
  font-size: 60px;
  color: #556ee6;
}
.choosePic {
  display: flex;
  cursor: pointer;
  margin-right: 30px;
  justify-content: center;
  align-items: center;
  color: white;
  background: #556ee6;
  border-radius: 2.6px;
  width: 99px;
  height: 28px;
}
.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px;
    color: white;
    background: #556ee6;
    border-radius: 4px;
  }
  .cancelButton {
    padding: 6px 90px;
    margin-left: 12px;
    color: white;
    background: #74788d;
    border-radius: 4px;
  }
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.submitButton {
  font-size: 14px !important;
  padding: 8px 45px !important;
  color: white !important;
  background: #556ee6 !important;
  border: 1px solid #556ee6 !important;
  box-sizing: border-box !important;
  border-radius: 4px !important;
}
.cancleButton {
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.user-avatar {
  width: 67px;
  height: 67px;
  border-radius: 50%;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.alert-popUp {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  background: white;
  border: none;
  align-items: center;
  min-width: 450px;
  border-radius: 9px;
  height: 90px;
  text-align: right;
  position: fixed;
  z-index: 9999;
  bottom: 50px;
  right: 275px;
}
::v-deep .alert {
  padding: 0;
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo-main {
  display: flex;
}
.uploaded-photo {
  height: 120px;
  width: 160px;
  position: relative;
  margin-left: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo {
  width: 243px;
  height: 157px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
    // font-size: 20px;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    // font-size: 18px;
    color: #ff4861;
    // font-weight: 100;
  }
}
.previewImage {
  border-radius: 4px;
}
</style>
